module.exports = __webpack_public_path__ + "media/images/star-half-f6a338183a042a5757af8e08ee0cc282.svg";